import { getNominationRoundYear } from './getNominationRoundYear';
import {
  CM_PRIMARY_ID,
  SE_COMMITTEE_ID,
  NOMINATION_STATUS,
  ELECTION_TYPE,
} from './constants';

export const getCommitteeCandidateCount = ({
  committeeId,
  nominationArray,
  candidateArray,
  nominationStateArray,
  proposerSeconder,
  showMyAllocations,
  isCouncilMember,
  isAdmin,
  userId,
  selectedNominationStatus,
  selectedRankingFilter,
}) => {
  if (!nominationArray || !candidateArray) {
    return 0;
  }

  const currentYear = getNominationRoundYear(new Date());

  const count = nominationArray.filter((nomination) => {
    let matchesCommittee = false;
    if (committeeId === CM_PRIMARY_ID) {
      matchesCommittee =
        nomination.attributes.electionTypeId ===
        ELECTION_TYPE.CORRESPONDING_MEMBER;
    } else if (committeeId === SE_COMMITTEE_ID) {
      matchesCommittee =
        nomination.attributes.electionTypeId === ELECTION_TYPE.SPECIAL_ELECTION;
    } else {
      matchesCommittee =
        nomination.attributes.sectionalCommitteeId === committeeId;
    }

    if (!matchesCommittee) return false;

    if (
      ![
        NOMINATION_STATUS.SUBMITTED,
        NOMINATION_STATUS.SHORTLISTED,
        NOMINATION_STATUS.RECOMMENDED,
      ].includes(nomination.attributes.nominationStatusTypeId)
    ) {
      return false;
    }

    const nominationReceivedEmailDate = proposerSeconder?.find(
      (proposer) => proposer.attributes.nominationId === nomination.id,
    );
    const nominationReceivedDate =
      nominationReceivedEmailDate?.attributes?.nominationReceivedEmailDate;

    if (!nominationReceivedDate) {
      return false;
    }

    const nominationYear = getNominationRoundYear(
      new Date(nominationReceivedDate),
    );
    if (nominationYear !== currentYear) {
      return false;
    }

    if (showMyAllocations && isCouncilMember && !isAdmin) {
      const isAllocated = nominationStateArray?.some(
        (state) =>
          state.attributes?.nominationId === nomination.id &&
          (state.attributes?.councilMemberUserId ||
            state.councilMemberUserId) === userId,
      );
      if (!isAllocated) return false;
    }

    if (selectedNominationStatus && selectedNominationStatus.length > 0) {
      if (
        !selectedNominationStatus.includes(
          nomination.attributes.nominationStatusTypeId,
        )
      ) {
        return false;
      }
    }

    if (selectedRankingFilter) {
      const nominationState = nominationStateArray?.find(
        (state) => state.attributes.nominationId === nomination.id,
      );

      const hasRanking = nominationState?.attributes?.ranking != null;
      const isRecommendedToCouncil =
        nomination.attributes.nominationStatusTypeId ===
        NOMINATION_STATUS.RECOMMENDED;

      if (selectedRankingFilter === 'ranked' && !hasRanking) return false;
      if (selectedRankingFilter === 'unranked') {
        return isRecommendedToCouncil && !hasRanking;
      }
    }

    return true;
  }).length;

  return count;
};
